import { Component, OnInit } from '@angular/core';
import {LegalDocumentsService} from '../../../core/services/legal-documents.service';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss']
})
export class TermsDialogComponent implements OnInit {

  content: string;

  constructor(private legalDocumentsService: LegalDocumentsService) { }

  ngOnInit(): void {
    this.legalDocumentsService.getTermsContent()
      .pipe(take(1))
      .subscribe(
        response => {
          this.content = response?.[0]?.content ?? '<p>Nessun contenuto disponibile</p>';
        },
        error => {
          console.error(error);
          this.content = '<p>Errore durante il caricamento dei dati.</p>';
        });
  }

}
